<template>
	<span class="w-fit rounded-md bg-website-primary/5 px-10px py-1 text-sm text-website-primary">
		<slot />
	</span>
</template>
